/*
 * Cálculo de frete por CEP.
 *
 * Chama `/cart/shipping_rates.json`, o endpoint nativo da Shopify, que por sua
 * vez consulta os Carrier Services da loja — o Estoca CROSS entre eles. Não há
 * integração direta com o app: ele não publica script no storefront, e não
 * precisa.
 *
 * O endpoint exige o estado além do CEP. Em vez de depender de um serviço
 * externo para descobrir a UF, derivamos do próprio número: as faixas de CEP
 * dos Correios são fixas e públicas. Uma dependência a menos para cair.
 *
 * MODO PRODUTO
 * ------------
 * O endpoint cota o carrinho. Na página de produto queremos o frete DESTE
 * produto, e a Shopify não oferece nenhuma forma de cotar itens avulsos: não
 * há endpoint para isso na Ajax API, e a Storefront API exigiria um token que
 * o tema não tem. A única saída é passar pelo carrinho.
 *
 * Então: guardamos quanto havia daquela variante, adicionamos a quantidade
 * escolhida, cotamos e devolvemos o carrinho ao estado anterior. Duas
 * proteções, porque mexer no carrinho de alguém sem querer é inaceitável:
 *
 *   1. a restauração roda também quando a cotação falha;
 *   2. antes de tocar no carrinho gravamos a intenção no sessionStorage. Se a
 *      pessoa fechar a aba no meio, o próximo carregamento desfaz.
 */
(function () {
  'use strict';

  var raiz = document.querySelector('[data-yasy-frete]');
  if (!raiz) return;

  var form = raiz.querySelector('[data-frete-form]');
  var variante = raiz.getAttribute('data-frete-variante');
  var seletorCompra = raiz.getAttribute('data-frete-form-compra');
  var CHAVE_PENDENTE = 'yasy-frete-pendente';
  var campo = raiz.querySelector('[data-frete-cep]');
  var aviso = raiz.querySelector('[data-frete-aviso]');
  var lista = raiz.querySelector('[data-frete-lista]');
  var botao = form.querySelector('[type=submit]');

  /* Faixas oficiais dos Correios: [início, fim, UF]. */
  var FAIXAS = [
    [1000000, 19999999, 'São Paulo'],
    [20000000, 28999999, 'Rio de Janeiro'],
    [29000000, 29999999, 'Espírito Santo'],
    [30000000, 39999999, 'Minas Gerais'],
    [40000000, 48999999, 'Bahia'],
    [49000000, 49999999, 'Sergipe'],
    [50000000, 56999999, 'Pernambuco'],
    [57000000, 57999999, 'Alagoas'],
    [58000000, 58999999, 'Paraíba'],
    [59000000, 59999999, 'Rio Grande do Norte'],
    [60000000, 63999999, 'Ceará'],
    [64000000, 64999999, 'Piauí'],
    [65000000, 65999999, 'Maranhão'],
    [66000000, 68899999, 'Pará'],
    [68900000, 68999999, 'Amapá'],
    [69000000, 69299999, 'Amazonas'],
    [69300000, 69399999, 'Roraima'],
    [69400000, 69899999, 'Amazonas'],
    [69900000, 69999999, 'Acre'],
    [70000000, 72799999, 'Distrito Federal'],
    [72800000, 72999999, 'Goiás'],
    [73000000, 73699999, 'Distrito Federal'],
    [73700000, 76799999, 'Goiás'],
    [76800000, 76999999, 'Rondônia'],
    [77000000, 77999999, 'Tocantins'],
    [78000000, 78899999, 'Mato Grosso'],
    [78900000, 78999999, 'Rondônia'],
    [79000000, 79999999, 'Mato Grosso do Sul'],
    [80000000, 87999999, 'Paraná'],
    [88000000, 89999999, 'Santa Catarina'],
    [90000000, 99999999, 'Rio Grande do Sul']
  ];

  function estadoDoCep(digitos) {
    var n = parseInt(digitos, 10);
    for (var i = 0; i < FAIXAS.length; i++) {
      if (n >= FAIXAS[i][0] && n <= FAIXAS[i][1]) return FAIXAS[i][2];
    }
    return null;
  }

  function dinheiro(valor) {
    var n = parseFloat(valor);
    if (isNaN(n)) return valor;
    return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  function prazo(dias) {
    if (!dias || !dias.length) return '';
    if (dias[0] === dias[1]) return dias[0] === 1 ? '1 dia útil' : dias[0] + ' dias úteis';
    return dias[0] + ' a ' + dias[1] + ' dias úteis';
  }

  function mostrarAviso(texto) {
    aviso.textContent = texto;
    aviso.hidden = false;
    lista.hidden = true;
  }

  /* Máscara conforme digita, sem impedir apagar. */
  campo.addEventListener('input', function () {
    var d = campo.value.replace(/\D/g, '').slice(0, 8);
    campo.value = d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d;
  });

  function pedirJson(url, opcoes) {
    return fetch(url, opcoes).then(function (r) {
      if (!r.ok) throw new Error('http ' + r.status);
      return r.json();
    });
  }

  function quantidadeEscolhida() {
    if (!seletorCompra) return 1;
    var f = document.querySelector(seletorCompra);
    var campoQtd = f && f.querySelector('[name=quantity]');
    var n = campoQtd ? parseInt(campoQtd.value, 10) : 1;
    return n > 0 ? n : 1;
  }

  function quantidadeAtual(carrinho, id) {
    var total = 0;
    (carrinho.items || []).forEach(function (item) {
      if (String(item.id) === String(id)) total = item.quantity;
    });
    return total;
  }

  function restaurar(id, quantidade) {
    return pedirJson('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: String(id), quantity: quantidade })
    }).then(function () {
      try { sessionStorage.removeItem(CHAVE_PENDENTE); } catch (e) {}
    });
  }

  /* Se a aba morreu no meio de uma cotação anterior, desfaz agora. */
  (function limparPendencia() {
    try {
      var bruto = sessionStorage.getItem(CHAVE_PENDENTE);
      if (!bruto) return;
      var p = JSON.parse(bruto);
      restaurar(p.id, p.quantidade).catch(function () {});
    } catch (e) {}
  })();

  /* Cota o produto da página: adiciona, pergunta o frete, devolve o carrinho
     ao que era antes. */
  function cotarProduto(params) {
    var original;
    var qtd = quantidadeEscolhida();

    return pedirJson('/cart.js')
      .then(function (carrinho) {
        original = quantidadeAtual(carrinho, variante);
        try {
          sessionStorage.setItem(CHAVE_PENDENTE, JSON.stringify({ id: variante, quantidade: original }));
        } catch (e) {}
        return pedirJson('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(variante), quantity: qtd })
        });
      })
      .then(function () {
        return pedirJson('/cart/shipping_rates.json?' + params.toString());
      })
      .then(function (dados) {
        return restaurar(variante, original).then(function () { return dados; });
      })
      .catch(function (erro) {
        /* Falhou a cotação? O carrinho volta ao normal do mesmo jeito. */
        if (original === undefined) throw erro;
        return restaurar(variante, original).then(function () { throw erro; });
      });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    var digitos = campo.value.replace(/\D/g, '');
    if (digitos.length !== 8) {
      mostrarAviso('Digite os 8 números do CEP.');
      return;
    }

    var estado = estadoDoCep(digitos);
    if (!estado) {
      mostrarAviso('Não reconhecemos esse CEP. Confira os números.');
      return;
    }

    botao.setAttribute('aria-busy', 'true');
    mostrarAviso('Consultando…');

    var params = new URLSearchParams();
    params.set('shipping_address[zip]', digitos);
    params.set('shipping_address[country]', 'Brazil');
    params.set('shipping_address[province]', estado);

    var consulta = variante
      ? cotarProduto(params)
      : fetch('/cart/shipping_rates.json?' + params.toString()).then(function (r) {
          if (r.status === 422) throw new Error('endereco');
          if (!r.ok) throw new Error('http');
          return r.json();
        });

    consulta
      .then(function (dados) {
        var taxas = (dados && dados.shipping_rates) || [];
        if (!taxas.length) {
          mostrarAviso('Não encontramos entrega para esse CEP.');
          return;
        }

        lista.innerHTML = '';
        taxas.forEach(function (t) {
          var li = document.createElement('li');
          li.className = 'flex items-baseline justify-between gap-4 border-b border-primary/10 py-2 last:border-b-0';

          var nome = document.createElement('span');
          nome.className = 'font-sans-2 text-copy font-bold uppercase tracking-wide text-primary';
          nome.textContent = t.name;

          var detalhe = document.createElement('span');
          detalhe.className = 'text-copy text-primary';
          var p = prazo(t.delivery_days);
          detalhe.textContent = dinheiro(t.price) + (p ? ' · ' + p : '');

          li.appendChild(nome);
          li.appendChild(detalhe);
          lista.appendChild(li);
        });

        aviso.textContent = variante
          ? 'Entrega para ' + estado + '. Valores para ' + quantidadeEscolhida() + ' unidade(s) deste produto.'
          : 'Entrega para ' + estado + '. Valores para os itens do carrinho.';
        aviso.hidden = false;
        lista.hidden = false;
      })
      .catch(function (erro) {
        if (erro.message === 'endereco') {
          mostrarAviso('CEP fora da área de entrega.');
        } else {
          mostrarAviso('Não conseguimos calcular agora. Tente de novo em instantes.');
        }
      })
      .then(function () {
        botao.removeAttribute('aria-busy');
      });
  });
})();
